module.exports = __webpack_public_path__ + "static/media/jadavpurUniversity.2cf71e11.png";